import { Component, OnInit } from '@angular/core';
import { ProductsService } from 'src/app/services/producto/products.service';
import { Router } from "@angular/router";
import { listLazyRoutes } from '@angular/compiler/src/aot/lazy_routes';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  public products:any=[
    {
    color: "",
    dep_calidad: "",
    fecha: "",
    id: "",
    libre: "",
    manchas: "",
    olor: "",
    producto: "",
    pudedrumbre: "",
    sabor: "",
    textura: "",
    transporte: "",
    trazabilidad:""
    }
      
  ];
  constructor(private productService:ProductsService,private router:Router) {
 
   this.listar();
    
   }
   listar(){
    this.productService.getListProducts().subscribe((data:any)=>{
      console.log(data);
      this.products=data.productos;
    });
   }
  ngOnInit() {
  }

  editar(id){
  console.log(id);
  this.router.navigate(['/producto',id]);
  }

  deleteProduct(id){
    this.productService.deleteProduct(id).subscribe(resp=>{
      console.log(resp);
      this.listar();
    })
    ,error=>{
        console.log(error);
      };
  }
  crear(){
    this.router.navigate(['/producto/crear']);
  }
}
